/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var symphony = window.symphony || {};

symphony.config = {
	latLong: [],
	zip: undefined,
	updateResults: false,
	utilities: {
		modal: {},
		expandingHeader: $('.js-doesExpand')
	},
	properties: null,
	conductorProperties: null
}

symphony.site = {
	common: {
		init: function () {
			symphony.handlebarsHelpers();
			//symphony.crossStorage();
			symphony.accordionDisplay();
			symphony.alertsDisplay();
			symphony.cardsDisplay();
			symphony.checkHeroExistence();
			symphony.defaultModal();
			symphony.detectFeatures();
			symphony.donateHeaderActions();
			//symphony.donationsModal();
			//symphony.fitVids();
			symphony.geolocate();
			symphony.getHelpHeader();
			symphony.givingToolbar();
			symphony.operationHoursDisplay();
			//symphony.parseEvents();
			symphony.scrollToNextSection();
			symphony.showOnHover();
			symphony.stickyFooter();
			symphony.stickyNav();
			symphony.thumbnailSlider();
			symphony.toggleMenu();

			symphony.heroSlider();
			symphony.videoModal();
			symphony.waysToGiveGrid();
			symphony.gmapPopulation();
			symphony.advisoryBoardLeadForm();
			symphony.initCarousel();
			symphony.agenda.init();
			symphony.siteSearch.init();
			symphony.expandingText();
			symphony.freeTextArea.init();
			symphony.phoneNumberConverter.init();

			// Row modules
			symphony.rowDonate();

			symphony.utagEvents();
			symphony.registerEvents();
		}
	},
	home: {
		init: function () {}
	},
	get_help: {
		init: function () {
			bridgesWrapper.init();
		}
	},
	stories: {
		init: function () {
			// applies to THQ Master site "stories" page
			symphony.getWordpressStories();
		}
	},
	newsarticles: {
		init: function () {
			// applies to local site "allstories" dynamic view
			if ((useWpStories && hiddenPages.indexOf('pressreleases') > -1) || (canUseWordpressFeed && wordpressFeedUrl != '')) {
				symphony.getLocalStories();
			}
		}
	},
	advisory_board: {
		init: function () {}
	},
	ministry: {
		init: function () {}
	},
	waystogive: {
		init: function () {}
	},
	landingpage: {
		init: function () {}
	},
	style_guide: {
		init: function () {

			function htmlEntities(str) {
				return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
			}

			symphony.site.style_guide.toggleCode = function (el) {
				$(el).parent().find('.component-wrapper').toggleClass('isSwitched');
				if ($(el).parent().find('.component-wrapper').hasClass('isSwitched')) {
					$(el).parent().find('.component-flipper').css('height', $(el).parent().find('.component-html').height());
				} else {
					$(el).parent().find('.component-flipper').css('height', $(el).parent().find('.component-output').height());
				}

			}

			function setHeights() {
				$.each($('.component-output'), function (el) {
					var height = $(this).outerHeight();
					$(this).parent().css('height', height);
				});

				$('body').addClass('hasLoaded');
			}

			var flyoutNav = $('.flyoutNav');
			var globalHeaderNav = $('.globalHeader-nav');

			flyoutNav.empty();
			globalHeaderNav.empty();

			$.get('/' + thqUrlAlias + '/references', function (data) {

				var html = $('<html />').html(data);
				var divs = $(html).find('#page > div:not(.flyoutContainer)');

				$.each(divs, function () {

					var object = {
						html: $(this).html(),
						docs: $(this).find('.documentation').html(),
						className: $(this).data('name')
					};

					$('.componentContainer').append(symphony.templates.component(object));

					flyoutNav.append('<li class="flyoutNavItem"><a class="flyoutNavItem-link" href="#' + _.camelCase(object.className) + '">' + object.className + '</a></li>');

					setTimeout(setHeights, 1000);

					symphony.rowDonate();

				});

				Prism.highlightAll();

				$('.flyoutNavItem-link').on('click', function (e) {

					e.preventDefault();

					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

					if (target.length) {
						$('html, body').animate({
							scrollTop: target.offset().top + -75
						}, 1000);
						return false;
					}

				});


			});

			window.onresize = setHeights;


		}
	},
	press_releases: {
		init: function () {
			symphony.pressReleaseGrid();
		}
	},
	contact_us: {
		init: function () {
			symphony.getWufooScript();

			$('form.wufoo').on('submit', function (e) {
				utag.link({
					"event_type": "form_submit",
					"customer_name": $('form.wufoo').find('.contactName').val(),
					"customer_location": $('form.wufoo').find('.contactLocation').val(),
					"customer_email": $('form.wufoo').find('.contactEmail').val(),
					"form_selection": $('form.wufoo').find('.contactSelection').val(),
					"site_domain": location.hostname,
					"site_url": location.href
				});
			});

		}
	},
	search_results: {
		init: function () {
			var slides = $('.impactStories-slide');
			slides.has('a[href*="style_guide"]').css('display', 'none');
			slides.has('a[href*="references"]').css('display', 'none');
		}
	},
	location_search: {
		conductorSettings: {},
		mappings: [],
		init: function () {
			// load a default/sticky header with no need for hero image
			$.ajax({
				url: '/' + conductorUrlAlias + '/json/properties',
				type: "GET",
				dataType: "json",
				success: function (data) {
					var gdosProperty = data.objects.find(d => d.name == "gdosMapping");
					if (gdosProperty !== null && gdosProperty !== undefined) {
						var propData = JSON.parse(gdosProperty.value);
						var mappings = propData.objects; 
						symphony.site.location_search.mappings = mappings.sort(function (a, b) {
							return a.title - b.title
						})
					}

					function paramReplace(name, string, value) {
						// Find the param with regex
						// Grab the first character in the returned string (should be ? or &)
						// Replace our href string with our new value, passing on the name and delimeter
		
						var re = new RegExp("[\\?&]" + name + "=([^&#]*)");
						var matches = re.exec(string);
						var newString;
		
						if (matches === null) {
							// if there are no params, append the parameter
							newString = string + '?' + name + '=' + value;
						} else {
							var delimeter = matches[0].charAt(0);
							newString = string.replace(re, delimeter + name + "=" + value);
						}
						return newString;
					}
		
					function getZip(city) {
						$.get('//maps.googleapis.com/maps/api/geocode/json?address=' + city + '&sensor=true', function (response) {
							if (response.results.length > 0) {
								gdosWrapper.config.latLong = [response.results[0].geometry.location.lat, response.results[0].geometry.location.lng];
								gdosWrapper.getCenters(gdosWrapper.config.latLong[0], gdosWrapper.config.latLong[1], null).done(function (data) {
		
									gdosWrapper.config.gdosResults = gdosWrapper.parseResults(data.objects);
		
									gdosWrapper.storeResults(JSON.stringify(gdosWrapper.config.gdosResults));
		
									// display results in handlebars template
									renderGdosResults();
		
									var d = utag_data || {};
									d.site_section = 'Search';
									d.site_type = 'SAL:' + symphonyTerritory;
									d.loc_search_term = city;
									d.loc_search_results = gdosWrapper.config.gdosResults.length.toString();
									d.login_status = 'Not Logged In';
									d.territory_division = symphonyTerritory;
									d.event_type = 'loc_search';
									symphony.utagView(d);
		
								});
							}
						});
					}
		
					$('.js-gdosSearch').on('click', function (e) {
						var inputVal = $(this).parent().find('#zip').val();
						localStorage.removeItem('gdosResults');
						var reg = new RegExp('^[0-9]+$');
						localStorage.setItem("locsearch-zip", JSON.stringify(inputVal));
						if (!reg.test(inputVal)) {
							getZip(inputVal);
						}
						return;
					});
		
					$('body').on('click', '.gdosResults-serviceList a', function (e) {
						e.preventDefault();
						e.stopPropagation();
						localStorage.removeItem('gdosResults');
						window.location.assign($(this).attr('href'));
					});
		
					if (window.localStorage && localStorage.getItem('locsearch-zip') !== null) {
						$('.section').find('#zip').val(JSON.parse(localStorage.getItem('locsearch-zip')));
					}
		
					symphony.config.zip = symphony.getURLParam('location');
		
					if (symphony === undefined || symphony.config.zip === undefined) {
						var map = new GMaps({
							el: "#map",
							zoom: 5,
							lat: thqLatitude,
							lng: thqLongitude,
							mapTypeId: google.maps.MapTypeId.ROADMAP,
							disableDefaultUI: true,
							draggable: true
						});
					} else {
						$('.section').find('#zip').val(symphony.config.zip);
					}
		
					$('#zip').val(symphony.config.zip);
		
					// Do we already have stored results?
					if (gdosWrapper.validateData(localStorage.getItem("gdosResults"))) {
		
						getSavedResults();
		
					} else {
		
						getNewResults();
		
					}
		
					window.onpopstate = function () {
						getNewResults();
					};
		
					function getSavedResults() {
						if (symphony.config.updateResults === true) {
							getNewResults();
						}
		
						gdosWrapper.config.gdosResults = gdosWrapper.parseResults(localStorage.getItem("gdosResults"));
		
						renderGdosResults();
		
						var d = utag_data || {};
						d.site_section = 'Search';
						d.site_type = 'SAL:' + symphonyTerritory;
						d.loc_search_term = JSON.parse(localStorage.getItem('locsearch-zip')) || "";
						if (gdosWrapper.config.gdosResults) {
							d.loc_search_results = gdosWrapper.config.gdosResults.length.toString();
						}
						d.login_status = 'Not Logged In';
						d.territory_division = symphonyTerritory;
						d.event_type = 'loc_search';
						symphony.utagView(d, false);
					}
		
					function getNewResults() {
						localStorage.removeItem('gdosResults');
		
						var location = symphony.getURLParam('location') || JSON.parse(localStorage.getItem('locsearch-zip')) || $.trim($('input#zip').val());
						var mappingId = symphony.getURLParam('map');
						var activeMapping = null;

						var categories = ''
						if (mappingId != undefined) {
							var activeMapping = symphony.site.location_search.mappings.find(m => m.id == mappingId);

							if (activeMapping.categories.length > 0) {
								activeMapping.categories.forEach(function (c, index) {
									categories += `${c.id},`
								});
							}
						}
		
						if (location == undefined || location == null || location == "") return;
		
						gdosWrapper.getLatLong(location).done(function (data) {
		
							gdosWrapper.config.latLong = [data.latitude, data.longitude];
		
							gdosWrapper.getCenters(gdosWrapper.config.latLong[0], gdosWrapper.config.latLong[1], mappingId == undefined ? null : categories).done(function (data) {
								var serviceIds = [];
								
								if (activeMapping != null && activeMapping.categories.length > 0) {
									activeMapping.categories.forEach(c => serviceIds = serviceIds.concat(c.serviceIds))
									var filteredResults = [];

									// var filteredResults =
									var match = false;
									data.objects.forEach(obj => {
										match = false;
										obj.services.forEach(s => {
											if (match) {
												return;
											}
											
											if (serviceIds.includes(s.id)) {
												match = true;
												return;
											}
										});
										if (match) {
											filteredResults.push(obj);
											return;
										}
									});

									gdosWrapper.config.gdosResults = gdosWrapper.parseResults(filteredResults);
								} else {
									gdosWrapper.config.gdosResults = gdosWrapper.parseResults(data.objects);
								}

								
		
								gdosWrapper.storeResults(JSON.stringify(gdosWrapper.config.gdosResults));
		
								// display results in handlebars template
								renderGdosResults();
		
								var d = utag_data || {};
								d.site_section = 'Search';
								d.site_type = 'SAL:' + symphonyTerritory;
								d.loc_search_term = location;
								d.loc_search_results = gdosWrapper.config.gdosResults.length.toString();
								d.login_status = 'Not Logged In';
								d.territory_division = symphonyTerritory;
								d.event_type = 'loc_search';
								symphony.utagView(d);
		
							});
						});
					}
		
					// filter results by corps, stores, arc centers, service centers, senior residences, drop off locations
		
					// add returned categories, "offerings" and "types" to select dropdowns for filtering
		
					function renderGdosResults() {
						gdosWrapper.config.groupedResults = gdosWrapper.groupResults(gdosWrapper.config.gdosResults, symphony.site.location_search.mappings);
						var gdosPromises = [];
						if (typeof gdosWrapper.config.groupedResults != "undefined") {
		
							for (var i = 0; i < gdosWrapper.config.groupedResults.length; i++) {
								gdosWrapper.config.groupedResults[i].hasWebsite = typeof gdosWrapper.config.groupedResults[i].primaryWebsite == "string" && gdosWrapper.config.groupedResults[i].primaryWebsite.trim() != "";
		
								if (gdosWrapper.config.groupedResults[i].hasWebsite) {
									var urlAlias = "";
									if (gdosWrapper.config.groupedResults[i].primaryWebsite.indexOf(".org/") > -1) {
										urlAlias = gdosWrapper.config.groupedResults[i].primaryWebsite.split(".org/")[1];
									}
									if (gdosWrapper.config.groupedResults[i].primaryWebsite.indexOf(".com/") > -1) {
										urlAlias = gdosWrapper.config.groupedResults[i].primaryWebsite.split(".com/")[1];
									}
									// remove trailing slashes
									while (urlAlias != urlAlias.replace(/\/$/, "")) {
										urlAlias = urlAlias.replace(/\/$/, "");
									}
									urlAlias = urlAlias.trim();
									gdosWrapper.config.groupedResults[i].urlAlias = urlAlias;
								}
		
								if (typeof gdosWrapper.config.groupedResults[i].wm4SiteId == "string" && gdosWrapper.config.groupedResults[i].wm4SiteId.trim() != "") {
									// check site settings by siteId
									gdosPromises.push(setVolunteerUrlViaSiteSettings(i, "/settings/by-id?id=" + gdosWrapper.config.groupedResults[i].wm4SiteId, urlAlias));
								} else if (gdosWrapper.config.groupedResults[i].hasWebsite) {
									// check site settings by site url
									if (gdosWrapper.config.groupedResults[i].urlAlias != "") {
										gdosPromises.push(setVolunteerUrlViaSiteSettings(i, "/settings/by-url?url=" + urlAlias, urlAlias));
									}
								}
							}
						}
		
						// don't want to make the wait time too great, so only wait 3 seconds before rendering the map
						var goAhead = false;
						setTimeout(function () {
							goAhead = true;
						}, 3000);
		
						var checkInterval = setInterval(function() {
							if ($.grep(gdosWrapper.config.groupedResults, function (x) { return x.pending == true; }).length == 0 || goAhead) {
								renderMap();
								clearInterval(checkInterval);
							}
						}, 500);
		
						// if (!useGdosVolunteerLink || gdosPromises.length == 0) {
						// 	renderMap();
						// } else {
						// 	Promise.all(gdosPromises)
						// 	.then(function () {
						// 		console.log('then')
						// 		renderMap();
						// 	})
						// 	.catch(function () {
						// 		console.log('catch')
						// 		renderMap();
						// 	});	
						// }
		
						function setVolunteerUrlViaSiteSettings(i, apiEndpoint, urlAlias) {
							gdosWrapper.config.groupedResults[i].pending = true;
							$.get(symphonyPropertyApi + apiEndpoint)
								.done(function (d) {
									d = typeof d == "string" ? JSON.parse(d) : d;
									if (Array.isArray(d)) {
										d = d[0];
									}
									if (typeof d.value != "undefined") {
										var settings = typeof d.value == "string" ? JSON.parse(d.value) : d.value;
										gdosWrapper.config.groupedResults[i].conductorUrlAlias = settings.conductorUrlAlias;
		
										if (symphony.site.location_search.useVolunteerLink(gdosWrapper.config.groupedResults[i].conductorUrlAlias)) {
											if (typeof settings.volunteerUrl != "undefined" && settings.volunteerUrl.trim() != "") {
												gdosWrapper.config.groupedResults[i].volunteerUrl = settings.volunteerUrl;
											} else if (!symphony.site.location_search.requireLocalVolunteerLink(gdosWrapper.config.groupedResults[i].conductorUrlAlias)) {
												// default all volunteer urls to [primaryWebsite]/volunteer
												if (gdosWrapper.config.groupedResults[i].hasWebsite) {
													var volunteerUrl = JSON.parse(JSON.stringify(gdosWrapper.config.groupedResults[i].primaryWebsite));
													// remove trailing slashes
													while (volunteerUrl != volunteerUrl.replace(/\/$/, "")) {
														volunteerUrl = volunteerUrl.replace(/\/$/, "");
													}
													gdosWrapper.config.groupedResults[i].volunteerUrl = volunteerUrl.replace(gdosWrapper.config.groupedResults[i].urlAlias, urlAlias) + "/volunteer";	
												}
											}
										}
									}
									gdosWrapper.config.groupedResults[i].pending = false;
								})
								.fail(function (err) {
									if (err.status == 404 && typeof urlAlias == "string" && urlAlias.indexOf('/') > -1) {
										urlAlias = urlAlias.split('/')[0];
										gdosPromises.push(setVolunteerUrlViaSiteSettings(i, "/settings/by-url?url=" + urlAlias, urlAlias));
									} else {
										gdosWrapper.config.groupedResults[i].pending = false;
									}
								});
						}
		
						function renderMap() {
							gdosWrapper.config.resultsContainer.empty().append(symphony.templates.gdosResults({
								centers: gdosWrapper.config.groupedResults
							}));
							gdosWrapper.createMap(gdosWrapper.config.gdosResults, '#map');
						}
							
					}
				},
				error: function (error) {
					console.log(`Error ${error}`);
				}
			});
		},

		getConductorSettings(conductorUrl) {
			$.ajax({
				url: symphonyPropertyApi + "/settings/by-url?url=" + conductorUrl,
				cache: false,
				type: 'GET',
				async: false,
				success: function (d) {
					d = typeof d == "string" ? JSON.parse(d) : d;
					if (Array.isArray(d)) {
						d = d[0];
					}
					if (typeof d.value != "undefined") {
						symphony.site.location_search.conductorSettings[conductorUrl] = typeof d.value == "string" ? JSON.parse(d.value) : d.value;
					}
				}
			});
		},

		useVolunteerLink(conductorUrl) {
			if (typeof symphony.site.location_search.conductorSettings[conductorUrl] == "undefined") {
				this.getConductorSettings(conductorUrl);
			}
			return symphony.site.location_search.conductorSettings[conductorUrl].useGdosVolunteerLink === true;
		},

		requireLocalVolunteerLink(conductorUrl) {
			if (typeof symphony.site.location_search.conductorSettings[conductorUrl] == "undefined") {
				this.getConductorSettings(conductorUrl);
			}
			return symphony.site.location_search.conductorSettings[conductorUrl].requireLocalVolunteerLink === true;
		}
	},
	eventsarticles: {
		init: function () {
			symphony.parseEvents();
		}
	},

	animateScrollTo: function ($elm, offset, scrollSpeed) {
		offset = typeof offset == "undefined" ? 0 : offset;
		scrollSpeed = typeof scrollSpeed == "undefined" ? 1000 : scrollSpeed;

		var $container = $('html, body');
		if ($('.givingToolbar-toolbar').length > 0 && $('body.kroc-theme').length == 0) {
			offset = offset - $('.givingToolbar-toolbar').height();
		}
		if ($('.preview-container').length > 0) {
			$container = $('.preview-container');
		}

		if ($('body.kroc-theme').length > 0 && $('html').scrollTop() < $elm.offset().top + offset) {
			$container.animate({
				scrollTop: $elm.offset().top + offset
			}, scrollSpeed);
		} else {
			$container.animate({
				scrollTop: $elm.offset().top - $('header').outerHeight() + offset
			}, scrollSpeed);
		}
	}
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
	fire: function (func, funcname, args) {
		var namespace = symphony.site;
		funcname = (funcname === undefined) ? 'init' : funcname;
		if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
			namespace[func][funcname](args);
		}
	},
	loadEvents: function () {
		UTIL.fire('common');

		$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
			UTIL.fire(classnm);
		});
	},
	GetQueryStringParameterByName: function (name, url) {
		url = url || location.search;
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(url);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	},
	debounce: function (func, wait, immediate) {
		var timeout;

		return function executedFunction() {
			var context = this;
			var args = arguments;

			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};

			var callNow = immediate && !timeout;

			clearTimeout(timeout);

			timeout = setTimeout(later, wait);

			if (callNow) func.apply(context, args);
		};
	}
};

$(document).ready(UTIL.loadEvents);
